import { useContext } from "react";
import { IconButton } from "@mui/material";
import { LightMode, DarkMode } from "@mui/icons-material";
import { ThemeContext } from "./ThemeProviderWrapper";

const ThemeToggle = () => {
  const { toggleTheme, mode } = useContext(ThemeContext);

  return (
    <IconButton 
      onClick={toggleTheme} 
      color="inherit"
      sx={{
        color: mode === "light" ? "#333" : "#fff",
      }}
    >
      {mode === "light" ? <DarkMode /> : <LightMode />}
    </IconButton>
  );
};

export default ThemeToggle;
